<template>
    <div>
        <p>Loading... <a href="https://tiktok.com/@labyhelp_addon">Dont work? click here</a></p>
    </div>
</template>

<script>

window.location.href = "https://tiktok.com/@labyhelp_addon";

export default {
    name: "TikTok"
}
</script>

<style scoped>

</style>